import { atom } from "jotai";

export const notificationBarOpenAtom = atom<boolean>(false);
